import React from 'react';
import { useTranslation } from '@separate/hooks/translation';
import styles from './benefitsCarousel.module.scss';

const SavingCard = () => {
  const { t } = useTranslation();

  const benefits = [
    {
      id: 1,
      savings: t('benefits.savings.in_savings', { price: '45.00' }),
      title: t('benefits.savings.dental.title'),
      description: t('benefits.savings.dental.description'),
      regularPrice: '$102.00',
      perVisit: t('benefits.savings.dental.per_visit', { price: '57' })
    },
    {
      id: 2,
      savings: t('benefits.savings.in_savings', { price: '250.00' }),
      title: t('benefits.savings.telemedicine.title'),
      description: t('benefits.savings.telemedicine.description'),
      regularPrice: '$250.00',
      perVisit: t('benefits.savings.telemedicine.per_visit', { price: '0' })
    },
    {
      id: 3,
      savings: t('benefits.savings.in_savings', { price: '10.87' }),
      title: t('benefits.savings.pharmacy_lisinopril.title'),
      description: t('benefits.savings.pharmacy_lisinopril.description'),
      regularPrice: '$12.00',
      perVisit: t('benefits.savings.pharmacy_lisinopril.per_visit', { price: '1.13' })
    },
    {
      id: 4,
      savings: t('benefits.savings.in_savings', { price: '46.61' }),
      title: t('benefits.savings.pharmacy_amlodipine.title'),
      description: t('benefits.savings.pharmacy_amlodipine.description'),
      regularPrice: '$47.00',
      perVisit: t('benefits.savings.pharmacy_amlodipine.per_visit', { price: '0.39' })
    },
    {
      id: 5,
      savings: t('benefits.savings.in_savings', { price: '48.00' }),
      title: t('benefits.savings.vision.title'),
      description: t('benefits.savings.vision.description'),
      regularPrice: '$90.00',
      perVisit: t('benefits.savings.vision.per_visit', { price: '42' })
    }
  ];

  return (
    <>
      {benefits.map((benefit) => (
        <div key={benefit.id} className='p-2 mx-2'>
          <div className={styles.savingCard}>
            <div className={styles.header}>
              <p>{benefit.savings}</p>
            </div>

            <div className={styles.body}>
              <p className={styles.title}>{benefit.title}</p>
              <p className={styles.description}
                dangerouslySetInnerHTML={{
                  __html: benefit.description
                }}
              />
              <p className={styles.regularPrice}>{benefit.regularPrice}</p>
              <p className={styles.discountPrice}
                dangerouslySetInnerHTML={{
                  __html: benefit.perVisit
                }}
              />
            </div>

            <div className={styles.horizontalLine} />
            <div className={styles.footer}>
              <p dangerouslySetInnerHTML={{
                __html: t('benefits.savings.with_podersalud')
              }}
              />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default SavingCard;
